<template>
	<router-view />
</template>

<script>
	import Vue from 'vue';
	import VueHead from 'vue-head';
	import './styles/brand/common/common.scss';

	Vue.use(VueHead, {
		separator: '-',
		complement: 'Cognito Forms - Easily Build Powerful Forms'
	});

	Vue.mixin({
		watch: {
			'$route.path'() {
				this.$nextTick(() => this.$emit('updateHead'));
			}
		}
	});

	export default {
		created() {
			const html = document.documentElement;
			html.setAttribute('lang', 'en');
		},
		head: {
			meta: [
				{
					name: 'viewport',
					content: 'width=device-width, initial-scale = 1.0, minimal-ui'
				},
				{
					name: 'apple-mobile-web-app-capable',
					content: 'yes'
				},
				{
					he: 'X-UA-Compatible',
					content: 'IE=edge'
				},
				{ property: 'twitter:card', content: 'summary_large_image', id: 'twitter:card' },
				{ property: 'twitter:site', content: '@CognitoForms', id: 'twitter:site' },
				{ property: 'twitter:creator', content: '@CognitoForms', id: 'twitter:creator' }
			]
		}
	};
</script>